import Text from 'bloko/blocks/text';
import VSpacing from 'bloko/blocks/vSpacing';
import { TranslatedComponent } from 'bloko/common/hooks/useTranslations';

import translation from 'src/components/translation';
import { ZpTariff } from 'src/models/price/zpTariff';

import { GbbDivider } from 'src/components/Price/Gbb';

const TrlKeys = {
    [ZpTariff.ResumeAccessUnlimited]: 'price.tariffDescription.ZP_RESUME_ACCESS_UNLIMITED',
    [ZpTariff.ResumeAccessByPiece]: 'price.tariffDescription.ZP_RESUME_ACCESS_BY_PIECE',
    [ZpTariff.ResumeAccessByCategory]: 'price.tariffDescription.ZP_RESUME_ACCESS_BY_CATEGORY',
    [ZpTariff.Anonymous]: 'price.tariffDescription.ZP_ANONYMOUS',
    [ZpTariff.OptionPremium]: 'price.tariffDescription.OPTION_PREMIUM',
    [ZpTariff.Branding]: 'price.tariffDescription.VBC',
};

const TariffDescription: TranslatedComponent<{ tariffName: ZpTariff }> = ({ tariffName, trls }) => {
    return tariffName in TrlKeys ? (
        <>
            <VSpacing base={2} />
            <Text>{trls[TrlKeys[tariffName as keyof typeof TrlKeys]]}</Text>
            <VSpacing base={5} />
            <GbbDivider />
        </>
    ) : null;
};

export default translation(TariffDescription);
